<template>
  <form>
    <md-card v-if="currentTicket">
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Ticket {{ currentTicket.ticketCode }}
          <small>De {{ currentTicket.fullName }}</small>
        </h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Documento</label>
              <md-input
                disabled
                v-model="currentTicket.documentValue"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Correo</label>
              <md-input
                disabled
                v-model="currentTicket.email"
                type="email"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Celular</label>
              <md-input disabled v-model="currentTicket.cellphone"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>¿Está autenticado?</label>
              <md-input
                disabled
                v-bind:value="currentTicket.isAuthenticated == 1 ? 'Sí' : 'No'"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-66">
            <md-field>
              <label>Asunto</label>
              <md-input disabled v-model="currentTicket.subject"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Cuerpo del Ticket</label>
              <md-input disabled v-model="currentTicket.body"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Fecha de solicitud</label>
              <md-input
                disabled
                v-model="currentTicket.creationDate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Estado del ticket</label>
              <md-input
                disabled
                v-model="currentTicket.capCurrentStatus.stateName"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field class="md-layout-item" v-if="statusList.length">
              <label for="pages">Actualizar estado a</label>
              <md-select v-model="stateIdChange" name="pages">
                <md-option
                  v-for="item in statusList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div
            v-if="!constraintToDisableAnswer()"
            class="md-layout-item md-size-100 md-small-size-100"
          >
            <md-field maxlength="5">
              <label>Escribe una respuesta sobre este ticket</label>
              <md-textarea v-model="answer"></md-textarea>
            </md-field>
          </div>
          <!-- <div class="md-layout-item md-size-100 md-small-size-100">
            <h4 class="card-title">{{ fileName }}</h4>
            <div class="file-input">
              <div v-if="!imageRegular">
                <div class="image-container">
                  <img :src="regularImg" title="" />
                </div>
              </div>
              <div class="image-container" v-else>
                <img :src="imageRegular" />
              </div>
              <div class="button-container">
                <md-button
                  class="md-danger md-round"
                  @click="removeImage"
                  v-if="imageRegular"
                  ><i class="fa fa-times"></i>Eliminar</md-button
                >
                <md-button class="md-info md-round md-fileinput">
                  <template v-if="!imageRegular">Adjuntar</template>
                  <template v-else>Cambiar</template>
                  <input type="file" @change="onFileChange" />
                </md-button>
              </div>
            </div>
          </div> -->
          <div class="md-layout-item md-size-33">
            <md-button
              :disabled="constraintToDisableAnswer()"
              @click="replyTicket()"
              class="md-raised md-info mt-4"
              >Responder</md-button
            >
          </div>
          <div v-if="stateIdChange" class="md-layout-item md-size-33">
            <md-button @click="updateStatus()" class="md-raised md-primary mt-4"
              >Actualizar estado</md-button
            >
          </div>
          <div
            v-if="
              currentTicket.subject == getTicketTypeDomainValue() && !isClient()
            "
            class="md-layout-item md-size-33"
          >
            <md-button @click="goProfile()" class="md-raised md-primary mt-4"
              >Perfil del Cliente</md-button
            >
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import gql from "graphql-tag";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import Constants from "../../constants";
import Swal from "sweetalert2";
import axios from "axios";
import store from "../../store";
export default {
  components: {},
  name: "edit-profile-form",
  props: {
    regularImg: {
      type: String,
      default: "./img/capital77/file-icon.webp"
    },
    headerColor: {
      type: String,
      default: "blue"
    }
  },
  data() {
    return {
      imageRegular: null,
      multipartFile: new FormData(),
      currentTicket: null,
      stateIdChange: null,
      statusList: [],
      answer: null,
      fileName: "Archivo",
      client: null
    };
  },
  methods: {
    constraintToDisableAnswer() {
      return (
        (this.currentTicket.subject == this.getTicketTypeDomainValue() &&
          !this.isClient()) ||
        this.currentTicket.capCurrentStatus.stateId ==
          this.getTicketStatusClosed()
      );
    },
    isClient() {
      return Constants.getUserType() == Constants.CLIENT;
    },
    getTicketTypeDomainValue() {
      return Constants.EMAIL_TICKET_TYPE_VALUE;
    },
    getTicketStatusClosed() {
      return Constants.STATUS_TICKET_CLOSED;
    },
    goProfile() {
      this.$router.push("/client/" + this.client.accountId);
      this.$router.go();
    },
    replyTicket() {
      this.multipartFile.set("ticketCode", this.currentTicket.ticketCode);
      this.multipartFile.set("message", this.answer);
      this.multipartFile.set("isClient", this.isClient());
      axios({
        url: store.state.backend + "/sendReply",
        method: "POST",
        data: this.multipartFile,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data"
        }
      }).then(response => {
        var messageCompl = "";
        if (this.fileName != "Archivo")
          messageCompl = " Archivo: " + this.fileName;
        Swal.fire({
          title: "Respuesta enviada",
          text:
            "Tu respuesta ha sido enviada satisfactoriamente. Respuesta: " +
            this.answer +
            "." +
            messageCompl,
          confirmButtonClass: "md-button md-primary",
          buttonsStyling: false
        }).then(() => {
          this.$router.push("/tickets");
        });
      });
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      var partsName = file.name.split(".");
      var extension = partsName[partsName.length - 1];
      this.fileName = file.name;
      if (
        extension.toLowerCase() == "jpeg" ||
        extension.toLowerCase() == "png" ||
        extension.toLowerCase() == "jpg"
      ) {
        reader.onload = e => {
          vm.imageRegular = e.target.result;
          vm.multipartFile.set("file", file, file.name);
        };

        reader.readAsDataURL(file);
      } else if (file.size < 5000000) {
        reader.onload = e => {
          vm.imageRegular = "./img/capital77/file-check-icon.webp";
          vm.multipartFile.set("file", file, file.name);
        };

        reader.readAsDataURL(file);
      } else {
        Swal.fire({
          title: "Tamaño no permitido",
          text: "Sólo puedes cargar archivos menores a 5 Mb",
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
    removeImage: function() {
      this.imageRegular = "";
      this.fileName = "Archivo";
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (e.target.name) {
        this.createImage(files[0], "circle");
      } else {
        this.createImage(files[0]);
      }
    },
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    getName() {
      return "Cliente X";
    },
    updateStatus() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation updateTicket($ticketId: Int!, $statusId: Int!) {
              updateTicket(ticketId: $ticketId, statusId: $statusId) {
                ticketId

                capCurrentStatus {
                  stateName
                }
              }
            }
          `,
          variables: {
            ticketId: this.currentTicket.ticketId,
            statusId: this.stateIdChange
          },
          update: (cache, mutationResult) => {
            let creditResult = mutationResult.data.updateTicket;
            Swal.fire({
              title: "Ticket actualizado",
              text:
                "Ticket actualizado con estado " +
                creditResult.capCurrentStatus.stateName,
              confirmButtonClass: "md-button md-primary",
              buttonsStyling: false
            }).then(() => {
              this.$router.go();
            });
          }
        })
        .catch(error => {
          var errorMessage = null;
          if (error.graphQLErrors[0])
            errorMessage = error.graphQLErrors[0].message;
          else if (error.networkError)
            errorMessage = "Ha ocurrido un error de conexión";
          else errorMessage = "Ha ocurrido un error desde el servidor";

          Swal.fire({
            title: "Error",
            text: errorMessage,
            confirmButtonClass: "md-button md-danger",
            buttonsStyling: false
          });
        });
    }
  },
  mounted() {
    this.$apollo
      .query({
        query: gql`
          query findByTicketCode($ticketCode: String!) {
            findByTicketCode(ticketCode: $ticketCode) {
              ticketId
              ticketCode
              fullName
              documentValue
              cellphone
              email
              subject
              body
              capDocumentType {
                fieldValue
              }
              capCurrentStatus {
                stateId
                stateName
              }
              creationDate
            }
          }
        `,
        variables: {
          ticketCode: this.$route.params.ticketCode
        }
      })
      .then(data => {
        this.currentTicket = data.data.findByTicketCode;
        if (!this.isClient())
          this.$apollo
            .query({
              query: gql`
                query getFromToCurrentStateCredit($currentState: Int!) {
                  getFromToCurrentStateCredit(currentState: $currentState) {
                    id: stateId
                    name: stateName
                    description: stateDescription
                  }
                }
              `,
              variables: {
                currentState: this.currentTicket.capCurrentStatus.stateId
              }
            })
            .then(data => {
              this.statusList = data.data.getFromToCurrentStateCredit;
            })
            .catch(error => {
              Constants.catchError(
                error,
                this.$apollo.provider.defaultClient,
                this,
                false
              );
            });

        this.$apollo
          .query({
            query: gql`
              query findAccountByDocumentValue($documentValue: String!) {
                findAccountByDocumentValue(documentValue: $documentValue) {
                  accountId
                }
              }
            `,
            variables: {
              documentValue: this.currentTicket.documentValue
            }
          })
          .then(data => {
            this.client = data.data.findAccountByDocumentValue;
          })
          .catch(error => {
            Constants.catchError(
              error,
              this.$apollo.provider.defaultClient,
              this,
              false
            );
          });
      })
      .catch(error => {
        Constants.catchError(
          error,
          this.$apollo.provider.defaultClient,
          this,
          false
        );
      });
  }
};
</script>
<style></style>
